<div class="backdrop">
  @if (features$ | async; as features) {
    <div class="card-container">
      <button mat-mini-fab color="primary" [class.hidden]="carousel.currentIndex() === 0" class="hide-sm" (click)="prev()">
        <mat-icon>arrow_back</mat-icon>
      </button>
      <mat-card appearance="outlined">
        <mat-card-content>
          <app-carousel [index]="0" #carousel (panNext)="trackPanNext()" (panPrev)="trackPanPrev()">
            @for (feature of features; track feature) {
              <app-carousel-item>
                <img
                  app-image-swapper
                  [src]="feature.urls[0]"
                  [srcset]="feature.srcSets[0]"
                  [srcSets]="feature.srcSets"
                  alt="{{feature.name}}"
                  />
                  <h2>{{feature.name}}</h2>
                  @if (feature.link) {
                    <a mat-list-item href="{{feature.link}}" target="_blank" rel="noopener">
                      <span>
                        <b>{{ 'Learn More' | translate }}</b>
                      </span>
                    </a>
                  }
                  <p>{{feature.description}}</p>
                </app-carousel-item>
              }
            </app-carousel>
            <div class="page-indicator hide-gt-sm">
              @for (feature of features$ | async; track feature; let i = $index) {
                <span [ngClass]="{ active: carousel.currentIndex() === i }"></span>
              }
            </div>
            <button mat-raised-button (click)="dismiss()">{{ 'Get Started' | translate }}</button>
          </mat-card-content>
        </mat-card>
        <button mat-mini-fab color="primary" [class.hidden]="carousel.currentIndex() === features.length - 1" class="hide-sm" (click)="next()">
          <mat-icon>arrow_forward</mat-icon>
        </button>
      </div>
    }
  </div>
